import React, { useEffect } from "react";
import ReviewHistoryCard from "components/card/ReviewHistoryCard";
import { connect } from "react-redux";






const ReviewHistoryTable = ({
	recordList, 
	pagination, 
	doSearch, 
	filters, 
	doDelete,
	doRecordReset
}) => {


return (
		<div className="grid grid-cols-1 gap-3 p-1 h-[600px] overflow-y-auto">
			<div className="space-y-4">
				<ReviewHistoryCard
					name="Jennifer Lee"
					reviewPeriod="Q2 2025"
					overallRating="4.5"
					reviewDate="July 15, 2025"
					reviewedBy
					="John Smith"
				/>
				<ReviewHistoryCard
					name="Jennifer Lee"
					reviewPeriod="Q2 2025"
					overallRating="4.5"
					reviewDate="July 15, 2025"
					reviewedBy
					="John Smith"
				/>
				<ReviewHistoryCard
					name="Jennifer Lee"
					reviewPeriod="Q2 2025"
					overallRating="4.5"
					reviewDate="July 15, 2025"
					reviewedBy
					="John Smith"
				/>
				<ReviewHistoryCard
					name="Jennifer Lee"
					reviewPeriod="Q2 2025"
					overallRating="4.5"
					reviewDate="July 15, 2025"
					reviewedBy
					="John Smith"
				/>
			</div>

		</div>
			

  );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewHistoryTable);
